import type { DisplayPublic } from '../api';
import { ChannelChrome } from './ChannelChrome';

const ITEMS = [
  { name: 'Pizza Slice', price: 4 },
  { name: 'Hot Dog', price: 3.5 },
  { name: 'Nachos', price: 5 },
  { name: 'Soft Pretzel', price: 4 },
  { name: 'Soda', price: 3 },
  { name: 'Bottled Water', price: 2 },
  { name: 'Coffee', price: 3 },
  { name: 'Candy', price: 2 },
];

export function MenuChannel({
  display,
  connected,
  onUnpair,
}: {
  display: DisplayPublic;
  connected: boolean;
  onUnpair: () => void;
}) {
  return (
    <ChannelChrome display={display} connected={connected} onUnpair={onUnpair}>
      <div className="mx-auto w-full max-w-5xl px-12 py-12">
        <h1 className="text-7xl font-extrabold tracking-tight">Concessions</h1>
        <p className="mt-2 text-xl text-white/40">
          {display.venueName} · cash &amp; card accepted
        </p>
        <div className="mt-12 grid grid-cols-2 gap-x-12 gap-y-3">
          {ITEMS.map((i) => (
            <div
              key={i.name}
              className="flex items-baseline justify-between border-b border-dotted border-white/15 py-3"
            >
              <span className="text-3xl">{i.name}</span>
              <span className="font-mono text-3xl text-white/70">
                ${i.price.toFixed(2)}
              </span>
            </div>
          ))}
        </div>
        <p className="mt-12 text-center text-sm text-white/30">
          Menu channel · placeholder content
        </p>
      </div>
    </ChannelChrome>
  );
}
